import { UserGetResultT } from 'ui-io/user-io'

type NormalizeUserQueryData = {
  data: UserGetResultT | undefined
  username: string
}

const normalizeUserQueryData = ({ data, username }: NormalizeUserQueryData) => {
  type NormalizedUser = {
    email?: string
    name?: string
    properties?: {
      email?: string
      first_name?: string
      last_name?: string
    }
  }

  const directUser: NormalizedUser | undefined =
    data && typeof data === 'object' && 'user' in data
      ? (data.user as NormalizedUser | undefined)
      : (data as NormalizedUser | undefined)

  const properties = directUser?.properties ?? {}

  const email = properties.email ?? directUser?.email ?? ''
  const firstName = properties.first_name ?? directUser?.name?.split(' ')[0] ?? ''
  const lastName = properties.last_name ?? directUser?.name?.split(' ').slice(1).join(' ') ?? ''
  const displayName = `${firstName ?? ''} ${lastName ?? ''}`.trim() || username

  return {
    email,
    firstName,
    lastName,
    displayName,
  }
}

export default normalizeUserQueryData
